export default __webpack_public_path__ + "assets/images/favicon.07091fc6c3d3162e9d25766cdfe4547c.ico";